'use client';

import { useParams, useRouter } from 'next/navigation';
import React, { FC } from 'react';

import { GameType } from '@/api/services/GameService/types';
import Image from '@/components/core/Image';
import Link from '@/components/core/Link';
import { useDeviceSize } from '@/hooks/useDeviceSize';
import { useTranslation } from '@/hooks/useTranslations';

type GameCardProps = {
  game: GameType;
};

const GameCard: FC<GameCardProps> = ({ game }) => {
  const params = useParams();
  const { t } = useTranslation();
  const router = useRouter();
  const isMobile = useDeviceSize();

  return (
    <div
      className="our-cabinets-game-item"
      style={
        {
          '--cardColor': game.pageColor?.match(/\d+/g)?.join(', ') || 'default-color',
        } as React.CSSProperties
      }
      onClick={() => {
        if (isMobile)
          router.push(`/${params.lang}/products/games/${game.categorySlug}/${game.slug}`);
      }}
    >
      <div className="our-cabinets-game-img-wrp">
        <img src={game.logo} alt={game.alt} />
      </div>
      <div className="our-cabinets-game-btn-wrp">
        <div className="our-cabinets-game-btn-inner">
          <div className="our-cabinets-game-info-wrp">
            <div className="our-cabinets-game-info-item">
              <p className="our-cabinets-game-name">{game.name}</p>
            </div>
          </div>
          <div className="our-cabinets-game-btn">
            <Link
              href={`/${params.lang}/products/games/${game.categorySlug}/${game.slug}`}
              className="button btnTypeSmall btnTypeCopy fullWidth"
            >
              <p className="mobBtnTxt">{t('LandBased-Benefit 6 Button')}</p>
              <i className="bc-i-go-to btnIcon btnIconSmall" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameCard;
